import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {UserListComponent} from './user-list.component';
import {UserFormComponent} from './user-form.component';
import {AuthGuard} from "../auth/auth.guard";

const usersRoutes: Routes = [
    {
        path: 'users',
        component: UserListComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'users/:id',
        component: UserFormComponent,
        canActivate: [AuthGuard]
    }
];

export const usersRouting:ModuleWithProviders = RouterModule.forChild(usersRoutes);


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/users/users.routing.ts